
<template>
    <div >
        <div class="news-bg" >
            <div class="container ">
                <el-button type="text" link @click="$router.go(-1);" class="btnReturn ">
                 <div class="flx-center">
                    <img style="width: 18px;height: 18px;margin-right: 5px;" :src="$ossUrl+'icons/returnOrder.png'" alt=""/>
                    <span  style="color: black;font-size: 18px;line-height: 18px;">返回</span>
                 </div>
              </el-button>
              <div v-if="id === 13" class="newsDetail-article13">
                <div>
                  <div class="newsDetailTop">
                    <div class="newsDetailTitle">
                    {{newsContent[12].title}}
                   </div>
                   <div class="newsListTime">{{newsContent[12].time}} </div>
                </div>
                <div class="newsContent" v-html="newsContent[12].contentFirst"/>
                <img class="newsDetailImg" :src='newsContent[12].imgsList[0]' alt=''>
                <div class="newsContent" v-html="newsContent[12].contentSecond"/>
                <div class="newsContent" v-html="newsContent[12].contentThird"/>
                <div class="newsContent" v-html="newsContent[12].contentForth"/>
                <div class="newsContent" v-html="newsContent[12].contentFive"/>
                <div class="newsContent" v-html="newsContent[12].contentSix"/>
                <div class="newsContent" v-html="newsContent[12].contentSeven"/>
                <img class="newsDetailImg" style="width: 280px; max-width: 100%;" :src='newsContent[12].imgsList[1]' alt=''>
                <div class="newsContent" v-html="newsContent[12].contentEight"/>
                </div>
              </div>
              <div v-if="id === 12">
                <div>
                  <div class="newsDetailTop">
                    <div class="newsDetailTitle">
                    {{newsContent[11].title}}
                   </div>
                   <div class="newsListTime">{{newsContent[11].time}} </div>
                </div>
                <img class="newsDetailImg" :src='newsContent[11].imgsList[0]' alt=''>
                <div class="newsContent" v-html="newsContent[11].contentFirst"/>
                <div class="newsContent" v-html="newsContent[11].contentSecond"/>
                <div class="newsContent" v-html="newsContent[11].contentThird"/>
                <div class="newsContent" v-html="newsContent[11].contentForth"/>
                <div class="newsContent" v-html="newsContent[11].contentFive"/>
                <div class="newsContent" v-html="newsContent[11].contentSix"/>
                <div class="newsContent" v-html="newsContent[11].contentSeven"/>
                <div class="newsContent" v-html="newsContent[11].contentEight"/>
                <img class="newsDetailImg" :src='newsContent[11].imgsList[1]' alt=''>
                <div class="newsContent" v-html="newsContent[11].contentNine"/>
                <img class="newsDetailImg" :src='newsContent[11].imgsList[2]' alt=''>
                <div class="newsContent" v-html="newsContent[11].contentTen"/>
                <div class="newsContent" v-html="newsContent[11].contentEleven"/>
                <div class="newsContent" v-html="newsContent[11].contentTwelve"/>
                <img class="newsDetailImg" :src='newsContent[11].imgsList[3]' alt=''>
                <img class="newsDetailImg" :src='newsContent[11].imgsList[4]' alt=''>
                <div class="newsContent" v-html="newsContent[11].contentThirteen"/>
                <img class="newsDetailImg" style="width: 200px" :src='newsContent[11].imgsList[5]' alt=''>
                <div class="newsContent" v-html="newsContent[11].contentFourteen"/>
                </div>
              </div>
              <div v-if="id === 0"> 
                <div class="newsDetailTop">
                  <div class="newsDetailTitle">
                    {{newsContent[10].title}}
                  </div>
                  <div class="newsContent" v-html="newsContent[10].contentFirst"></div>
                   <div class="newsListTime">{{newsContent[10].time}} </div>
                </div>
                
                <div class="newsContent" v-html="newsContent[10].contentSecond" />
                <img class="newsDetailImg" :src='newsContent[10].imgsList[0]' alt=''>
                <div class="newsContent" v-html="newsContent[10].contentThird"/>
                <div class="newsContent" v-html="newsContent[10].contentForth"/>
                <div class="newsContent" v-html="newsContent[10].contentFive"/>
                <div class="newsContent" v-html="newsContent[10].contentSix"/>
                <div class="newsContent" v-html="newsContent[10].contentSeven"/>
                <div class="newsContent" v-html="newsContent[10].contentEight"/>
                <div class="newsContent" v-html="newsContent[10].contentNine"/>
                <div class="newsContent" v-html="newsContent[10].contentTen"/>
                <div class="newsContent" v-html="newsContent[10].contentEleven" />
                <div class="newsContent" v-html="newsContent[10].contentTwelve" />
                <div class="newsContent" v-html="newsContent[10].contentThirteen" />
                <div class="newsContent" v-html="newsContent[10].contentFourteen" />
                <div class="newsContent" v-html="newsContent[10].contentFifteen" />
                <div class="newsContent" v-html="newsContent[10].contentSixteen" />
                <div class="newsContent" v-html="newsContent[10].contentSeventeen" />
                <img class="newsDetailImg"   :src='newsContent[10].imgsList[1]' alt=''>
                <div class="newsContent" v-html="newsContent[10].contentEighteen"/>
                <div class="newsContent" v-html="newsContent[10].contentNineteen"/>
                <div class="newsContent" v-html="newsContent[10].contentTwenty"/>
                <img class="newsDetailImg"   :src='newsContent[10].imgsList[2]' alt=''>
                <div class="newsContent" v-html="newsContent[10].contentTwentyOne"/>
                <img class="newsDetailImg"   :src='newsContent[10].imgsList[3]' alt=''>
                <div class="newsContent" v-html="newsContent[10].contentTwentyTwo"/>
                <img class="newsDetailImg"   :src='newsContent[10].imgsList[4]' alt=''>
                <div class="newsContent" v-html="newsContent[10].contentTwentyThree"/>
                <img class="newsDetailImg"   :src='newsContent[10].imgsList[5]' alt=''>
                <div class="newsContent" v-html="newsContent[10].contentTwentyFour"/>
                <div class="newsContent" v-html="newsContent[10].contentTwentyFive"/>
                <div class="newsContent" v-html="newsContent[10].contentTwentySix"/>
                <img class="newsDetailImg"   :src='newsContent[10].imgsList[6]' alt=''>
                <div class="newsContent" v-html="newsContent[10].contentTwentySeven"/>
                
              </div>
              <div v-if="id === 1">
                <div >
                  <div class="newsDetailTop">
                    <div class="newsDetailTitle">
                    {{newsContent[0].title}}
                   </div>
                   <div class="newsListTime">{{newsContent[0].time}} </div>
                </div>
                <img class="newsDetailImg"   :src='newsContent[0].imgsList[0]' alt=''>
               
                <div class="newsContent" v-html="newsContent[0].contentFirst"/>
                <img class="newsDetailImg"   :src='newsContent[0].imgsList[1]' alt=''>
                <div class="newsContent" v-html="newsContent[0].contentSecond"/>
                <img class="newsDetailImg"    :src='newsContent[0].imgsList[2]' alt=''>
                <div class="newsContent" v-html="newsContent[0].contentThird"/>

                </div>
              </div>
              <div v-else-if="id === 2">
                <div >
                  <div class="newsDetailTop">
                    <div class="newsDetailTitle">
                    {{newsContent[1].title}}
                   </div>
                   <div class="newsListTime">{{newsContent[1].time}} </div>
                </div>
                <img class="newsDetailImg"   :src='newsContent[1].imgsList[0]' alt=''>
               
                <div class="newsContent" v-html="newsContent[1].contentFirst"/>
                <div >
                  <img class="newsDetailImg"    :src='newsContent[1].imgsList[1]' alt=''>
                  <img class="newsDetailImg" style="width:100px"  :src='newsContent[1].imgsList[2]' alt=''>
                </div>
                <div class="newsContent" v-html="newsContent[1].contentSecond"/>
                <div >
                  <img class="newsDetailImg"    :src='newsContent[1].imgsList[3]' alt=''>
                  <img class="newsDetailImg"   :src='newsContent[1].imgsList[4]' alt=''>
                </div>
                <div class="newsContent" v-html="newsContent[1].contentThird"/>
                <div >
                  <img class="newsDetailImg"    :src='newsContent[1].imgsList[5]' alt=''>
                  <img class="newsDetailImg"   :src='newsContent[1].imgsList[6]' alt=''>
                </div>
                <div class="newsContent" v-html="newsContent[1].contentForth"/>
                <div >
                  <img class="newsDetailImg"    :src='newsContent[1].imgsList[7]' alt=''>
                  <img class="newsDetailImg" style="width:400px"   :src='newsContent[1].imgsList[8]' alt=''>
                </div>
                <div class="newsContent" v-html="newsContent[1].contentFive"/>
                <div >
                  <img class="newsDetailImg"    :src='newsContent[1].imgsList[9]' alt=''>
                  <img class="newsDetailImg" style="width:200px"   :src='newsContent[1].imgsList[10]' alt=''>
                </div>
                <div class="newsContent" v-html="newsContent[1].contentSix"/>
                <div >
                  <img class="newsDetailImg"    :src='newsContent[1].imgsList[11]' alt=''>
                </div>
        
                </div>
              </div>
              <div v-else-if="id === 3">
                <div >
                  <div class="newsDetailTop">
                    <div class="newsDetailTitle">
                    {{newsContent[2].title}}
                   </div>
                   <div class="newsListTime">{{newsContent[2].time}} </div>
                </div>
                <img class="newsDetailImg"   :src='newsContent[2].imgsList[0]' alt=''>
               
                <div class="newsContent" v-html="newsContent[2].contentFirst"/>
                <img class="newsDetailImg"   :src='newsContent[2].imgsList[1]' alt=''>
                <div class="newsContent" v-html="newsContent[2].contentSecond"/>
                <img class="newsDetailImg"    :src='newsContent[2].imgsList[2]' alt=''>
                <div class="newsContent" v-html="newsContent[2].contentThird"/>

                </div>
              </div>
              <div v-else-if="id === 4">
                <div >
                  <div class="newsDetailTop">
                    <div class="newsDetailTitle">
                    {{newsContent[3].title}}
                   </div>
                   <div class="newsListTime">{{newsContent[3].time}} </div>
                </div>
                <img class="newsDetailImg"   :src='newsContent[3].imgsList[0]' alt=''>
               
                <div class="newsContent" v-html="newsContent[3].contentFirst"/>
                <img class="newsDetailImg"   :src='newsContent[3].imgsList[1]' alt=''>
                <div class="newsContent" v-html="newsContent[3].contentSecond"/>
                <img class="newsDetailImg"    :src='newsContent[3].imgsList[2]' alt=''>
                <div class="newsContent" v-html="newsContent[3].contentThird"/>

                </div>
              </div>
              <div v-else-if="id === 5">
                <div >
                  <div class="newsDetailTop">
                    <div class="newsDetailTitle">
                    {{newsContent[4].title}}
                   </div>
                   <div class="newsListTime">{{newsContent[4].time}} </div>
                </div>
                <img class="newsDetailImg"   :src='newsContent[4].imgsList[0]' alt=''>
               
                <div class="newsContent" v-html="newsContent[4].contentFirst"/>
                <img class="newsDetailImg"   :src='newsContent[4].imgsList[1]' alt=''>
                <img class="newsDetailImg"   :src='newsContent[4].imgsList[2]' alt=''>
                <div class="newsContent" v-html="newsContent[4].contentSecond"/>
                <img class="newsDetailImg"    :src='newsContent[4].imgsList[3]' alt=''>
                <div class="newsContent" v-html="newsContent[4].contentThird"/>
                <img class="newsDetailImg"    :src='newsContent[4].imgsList[4]' alt=''>
                <img class="newsDetailImg" style="width: 320px"    :src='newsContent[4].imgsList[5]' alt=''>


                </div>
              </div>
              <div v-else-if="id === 6">
                <div >
                  <div class="newsDetailTop">
                    <div class="newsDetailTitle">
                    {{newsContent[5].title}}
                   </div>
                   <div class="newsListTime">{{newsContent[5].time}} </div>
                </div>
                <img class="newsDetailImg"   :src='newsContent[5].imgsList[0]' alt=''>
               
                <div class="newsContent" v-html="newsContent[5].contentFirst"/>
                <img class="newsDetailImg"   :src='newsContent[5].imgsList[1]' alt=''>
                <div class="newsContent" v-html="newsContent[5].contentSecond"/>
                <img class="newsDetailImg"    :src='newsContent[5].imgsList[2]' alt=''>
                <div class="newsContent" v-html="newsContent[5].contentThird"/>


                </div>
              </div>
              <div v-else-if="id === 7">
                <div >
                  <div class="newsDetailTop">
                    <div class="newsDetailTitle">
                    {{newsContent[6].title}}
                   </div>
                   <div class="newsListTime">{{newsContent[6].time}} </div>
                </div>
                <div><img class="newsDetailImg"   :src='newsContent[6].imgsList[0]' alt=''></div>
                <div><img class="newsDetailImg"   :src='newsContent[6].imgsList[1]' alt=''></div>
                <div> <img class="newsDetailImg"   :src='newsContent[6].imgsList[2]' alt=''></div>
               
                <div class="newsContent" v-html="newsContent[6].contentFirst"/>
                <div> <img class="newsDetailImg"   :src='newsContent[6].imgsList[3]' alt=''></div>
                <div class="newsContent" v-html="newsContent[6].contentSecond"/>

                <div> <img class="newsDetailImg"   :src='newsContent[6].imgsList[4]' alt=''></div>
                <div> <img class="newsDetailImg"   :src='newsContent[6].imgsList[5]' alt=''></div>
                <div> <img class="newsDetailImg"   :src='newsContent[6].imgsList[6]' alt=''></div>
                <div> <img class="newsDetailImg"   :src='newsContent[6].imgsList[7]' alt=''></div>
                <div> <img class="newsDetailImg"   :src='newsContent[6].imgsList[8]' alt=''></div>
                <div class="newsContent" v-html="newsContent[6].contentThird"/>

                <img class="newsDetailImg"    :src='newsContent[6].imgsList[9]' alt=''>
                <img class="newsDetailImg" style="width: 250px"    :src='newsContent[6].imgsList[10]' alt=''>
                <div> <img class="newsDetailImg"   :src='newsContent[6].imgsList[11]' alt=''></div>
                <div class="newsContent" v-html="newsContent[6].contentForth"/>

                <div> <img class="newsDetailImg"   :src='newsContent[6].imgsList[12]' alt=''></div>
                <div> <img class="newsDetailImg"   :src='newsContent[6].imgsList[13]' alt=''></div>
                <div class="newsContent" v-html="newsContent[6].contentFive"/>
   


                </div>
              </div>
              <div v-else-if="id === 8">
                <div >
                  <div class="newsDetailTop">
                    <div class="newsDetailTitle">
                    {{newsContent[7].title}}
                   </div>
                   <div class="newsListTime">{{newsContent[7].time}} </div>
                </div>
                <div class="newsContent" v-html="newsContent[7].contentFirst"/>
                <img class="newsDetailImg"   :src='newsContent[7].imgsList[0]' alt=''>
                <div class="newsContent" v-html="newsContent[7].contentSecond"/>
                <div> <img class="newsDetailImg"   :src='newsContent[7].imgsList[1]' alt=''></div>
                <div> <img class="newsDetailImg"   :src='newsContent[7].imgsList[2]' alt=''></div>
                <div class="newsContent" v-html="newsContent[7].contentThird"/>
                <img class="newsDetailImg"   :src='newsContent[7].imgsList[3]' alt=''>
                <img class="newsDetailImg" style="height:300px"   :src='newsContent[7].imgsList[4]' alt=''>
                <img class="newsDetailImg" style="height:300px"   :src='newsContent[7].imgsList[5]' alt=''>
                <div class="newsContent" v-html="newsContent[7].contentForth"/>

                </div>
              </div>
              <div v-else-if="id === 9">
                <div >
                  <div class="newsDetailTop">
                    <div class="newsDetailTitle">
                    {{newsContent[8].title}}
                   </div>
                   <div class="newsListTime">{{newsContent[8].time}} </div>
                </div>
                <img class="newsDetailImg"   :src='newsContent[8].imgsList[0]' alt=''>
                <div class="newsContent" v-html="newsContent[8].contentFirst"/>
                <div> <img class="newsDetailImg"   :src='newsContent[8].imgsList[1]' alt=''></div>
                <div> <img class="newsDetailImg"   :src='newsContent[8].imgsList[2]' alt=''></div>
                <div class="newsContent" v-html="newsContent[8].contentSecond"/>
                <div> <img class="newsDetailImg"   :src='newsContent[8].imgsList[3]' alt=''></div>
                <div> <img class="newsDetailImg"   :src='newsContent[8].imgsList[4]' alt=''></div>
                <div> <img class="newsDetailImg"   :src='newsContent[8].imgsList[5]' alt=''></div>
                <div class="newsContent" v-html="newsContent[8].contentThird"/>
                <img class="newsDetailImg" style="height:300px"   :src='newsContent[8].imgsList[6]' alt=''>
                <img class="newsDetailImg" style="height:300px"   :src='newsContent[8].imgsList[7]' alt=''>
                <div class="newsContent" v-html="newsContent[8].contentForth"/>
                <div> <img class="newsDetailImg"   :src='newsContent[8].imgsList[8]' alt=''></div>
                <div class="newsContent" v-html="newsContent[8].contentFive"/>

                </div>
              </div>
              <div v-else-if="id === 10">
                <div >
                  <div class="newsDetailTop">
                    <div class="newsDetailTitle">
                    {{newsContent[9].title}}
                   </div>
                   <div class="newsListTime">{{newsContent[9].time}} </div>
                </div>
                <div class="newsContent" v-html="newsContent[9].contentFirst"/>
                <img class="newsDetailImg"   :src='newsContent[9].imgsList[0]' alt=''>
                <div class="newsContent" v-html="newsContent[9].contentSecond"/>
                <div> <img class="newsDetailImg"   :src='newsContent[9].imgsList[1]' alt=''></div>
                <div class="newsContent" v-html="newsContent[9].contentThird"/>
                <div> <img class="newsDetailImg"   :src='newsContent[9].imgsList[2]' alt=''></div>
                <div class="newsContent" v-html="newsContent[9].contentForth"/>
                <div> <img class="newsDetailImg"   :src='newsContent[9].imgsList[3]' alt=''></div>
                <div class="newsContent" v-html="newsContent[9].contentFive"/>
                <div> <img class="newsDetailImg"   :src='newsContent[9].imgsList[4]' alt=''></div>
                <div class="newsContent" v-html="newsContent[9].contentSix"/>
                
                <div class="flx-align-start"><img class="newsDetailImg"   :src='newsContent[9].imgsList[6]' alt=''> <img class="newsDetailImg"   :src='newsContent[9].imgsList[5]' alt=''></div> 

                </div>
              </div>
            </div> 
          </div>
          </div>
  
     
  </template>
  <script>
  export default {
    name:"newsDetail",
    components: {
     
      // Switcher
    },
    created() {
    console.log(this.$route.query.id)
    this.baseUrl = this.$root.$el.baseURI;
      console.log(this.baseUrl)
    },
    data() {
      return {
       id:+this.$route.query.id,
       baseUrl:'',
        newsContent:[
          {
            id:'1',
            title:"一波接一波，海运涨价潮为何停不下来？",
            time:"2024-05-09 17:01 · 美通供应链",
            contentFirst:"<p>12月15日，为期四天的2023亚马逊全球开店跨境峰会在深圳国际会展中心圆满结束。作为亚马逊目前规模最大的行业标志性盛会，这次筹备半年、三年多来首次线下峰会现场十分火爆。美通作为峰会金牌赞助商、亚马逊SPN物流服务商，展位反响热烈、人头攒动，以快捷优质、安全无忧为特色的国际物流服务在现场得到了一致认可与好评。</p> ",
            contentSecond:"<h4>国际政策</h4><p>这次全航线涨价从南美开始，南美涨价原因主要是巴西对中国新能源车未来7月以及未来继续加征关税，比亚迪要在巴西建厂预计2万个集装箱发，导致运力不够，中远撤下跑西非的船跑南美又导致西非普涨。另外美国大选都宣称未来对中国加征50-60%的关税，进而导致一些中国企业加大了南美投资力度。</p><h4>货量因素</h4><h5>货量因素</h5><p>这次全航线涨价从南美开始，南美涨价原因主要是巴西对中国新能源车未来7月以及未来继续加征关税，比亚迪要在巴西建厂预计2万个集装箱发，导致运力不够，中远撤下跑西非的船跑南美又导致西非普涨。另外美国大选都宣称未来对中国加征50-60%的关税，进而导致一些中国企业加大了南美投资力度。</p><h5>北美市场</h5><p>今年第一季度，随着全球经济逐步复苏，我国外贸出口呈现增长态势，中美贸易增加了8.1%。一方面货量上涨造成舱位紧张；另一方面船司抽调其他航线船舶支援欧、地航线造成空班；另年初巴拿马运河缺水通行限制，美东航线很多船舶被迫绕行好望角拉长航程；再叠加7月份亚马逊PRIME DAY导致近期市场出货量激增，各种原因都推动了运价的上涨。</p>",
            contentThird:"<h4>其他因素</h4><p>船司每年4-5月份为长约的签约季，各船司为争取较高的长约运价，可能存在刻意采取各种措施推高运价，对近期运价暴涨有一定影响。</p><p>海运费短期内走势如何？</p><p>据船司相关人员透露，6月份随着绕行的船舶纷纷返回亚洲，空班及缺柜现象均会得到一定程度的缓解，且5月份涨幅较大，预计6月份运价暴涨趋势不可持续。但红海局势的变化仍是影响集装箱航运市场走势的主要因素之一，未来一段时间内，红海局势仍不容乐观，故运价将会在一定时间内在比较高的区域内波动。</p>",
            imgsList:[
              '',
              this.$ossUrl+'images/news/newsDetail/1-2.png' ,
              this.$ossUrl+'images/news/newsDetail/1.png' ,
            ]
          },
          {
            id:'2',
            title:"喜讯丨美通连续斩获4项荣誉奖项！",
            time:" 2024-03-29 17:30 · 美通供应链",
            contentFirst:"<p>近日， 美通先后荣获“FBA物流十强企业”、“拉美出海2023年度优质服务企业”、“2023年度坂田街道经济发展卓越贡献奖”、“网商领军会员企业”等4项大奖，标志着美通在跨境电商物流服务领域的卓越表现得到高度认可，也是对美通始终坚持高效运营、优化业务流程以及提升客户满意度等方面的肯定。</p> <h4>2024晓生排行榜FBA物流十强企业</h4>",
            contentSecond:"<p>晓生排行榜是首份反映中国跨境电商物流领域企业成长与行业格局的榜单，已成为跨境电商物流领域企业品牌强背书以及行业格局演变的风向标。</p><p>此次评选根据参选企业的评审资料，结合行业公开信息进行调研和初筛，通过参选企业年营业额、货量规模、团队规模等可量化指标，结合业务模式、经营管理、知识产权/专利、既往荣誉等附加指标，进行综合评选。</p>",
            contentThird:"<p>今年是晓生排行榜发布的第四年，也是美通蝉联榜单的第四年。在全球地缘竞争加剧、供应链区域化迁移、贸易保护主义盛行等不确定性因素下，2023年美通围绕行业核心节点、聚焦细分市场都取得了一定的的发展成绩。在“2024晓生排行榜”中，美通荣获“FBA物流十强企业”荣誉。</p><h4>拉美出海2023年度优质服务企业</h4>",
            contentForth:"<p>广东省服务贸易协会拉美跨境电商专委会（简称“拉美会”）， 以广东省拉美跨境电商从业企业为基础，联合行业内各大知名企业和专家，共同搭建拉美出海生态赋能平台，促进行业健康发展。</p><p>在“拉美会周年庆典-拉美出海2023年度颁奖晚宴”中，美通荣获“拉美出海2023年度优质服务企业”。</p><h4>坂田街道办事处经济发展卓越贡献奖</h4>",
            contentFive:"<p>近日，坂田街道开展了“益企同行”系列活动启动仪式暨“政企面对面”交流座谈会。座谈会以“聚力西核谋发展 益企同行向未来”为主题，旨在深化政企合作，优化营商环境，推动辖区经济高质量发展。</p><p>会上，美通荣获由坂田街道办事处颁发的“2023年度坂田街道经济发展卓越贡献奖”。</p><h4>金华市网商协会网商领军会员企业</h4>",
            contentSix:"<p>金华市网商协会是金华市电子商务经营者和网络服务经营者自愿组成的行业性、地方性非营利性社会组织，由金华市部分产业园区、网商企业联合发起并经金华市民政局批准设立，现有会员企业近200家。</p><p>为选树一批在网商领域创新发展典型，金华市网商协会面向会员单位及合作伙伴开展了2023年度优秀网商评选活动。义乌美通以良好的业内口碑、较高的影响力与品牌知名度，成功入选“网商领军会员企业”！</p><h4>此次荣获多个奖项进一步增强了美通的良好市场口碑与特色品牌形象，也激励着美通在未来继续坚守初心，为客户提供更加专业、安全、便捷的物流解决方案，为行业向好向稳发展注入活力。同时，美通将继续关注社会组织、政府机构的益企活动与政策，积极投身经济建设，为区域经济发展贡献更多的力量！</h4>",
            imgsList:[
              this.$ossUrl+'images/news/newsDetail/2 (3).png' ,
              this.$ossUrl+'images/news/newsDetail/2 (7).jpg' ,
              this.$ossUrl+'images/news/newsDetail/2 (2).png' ,
              this.$ossUrl+'images/news/newsDetail/2 (5).jpg' ,
              this.$ossUrl+'images/news/newsDetail/2 (4).jpg' ,
              this.$ossUrl+'images/news/newsDetail/2 (8).jpg' ,
              this.$ossUrl+'images/news/newsDetail/2 (9).jpg' ,
              this.$ossUrl+'images/news/newsDetail/2 (1).jpg' ,
              this.$ossUrl+'images/news/newsDetail/2 (1).png' ,
              this.$ossUrl+'images/news/newsDetail/2 (2).jpg' ,
              this.$ossUrl+'images/news/newsDetail/2 (3).jpg' ,
              this.$ossUrl+'images/news/newsDetail/2 (6).jpg' ,
            ]
          },
          {
            id:'3',
            title:"亚马逊合规化丨如何填好IEN编号？变体违规了怎么办？",
            time:"2024-03-22 17:01 · 美通供应链",
            contentFirst:"<p>亚马逊近年来针对平台的合规化运营出台了一系列规则。近期，新的欧洲贸易合规要求——仓储服务运营商尽职调查方案（FHDDS），要求亚马逊英国站卖家及时完成合规，6月30日起IEN未合规将可能受限。而同时一批卖家收到变体不合规导致账户停用的通知，并下架了相关listing。</p><h4>关于英国站IEN号</h4><p>IEN是什么？</p><p>当商品进口到英国时，英国海关机构会分配IEN(Import Entry Number)。最常见的格式是“运输参考编号（MRN）”（替换之前在CHIEF系统中提供的条目参考编号）和S10（商品通过万国邮政联盟（当地邮局）配送）。</p><p>怎么看IEN号？</p><p>当卖家的货件进入英国并向海关当局申报时，海关当局会为货件分配一个IEN，因此做自税的卖家只要如实上传IEN号即可。</p><p>而对于走包税的卖家，则需要联系物流服务商拿到IEN号尽快上传到后台。但如果卖家走的是双清包税，不能排除一个IEN号码被多卖家多次填写的可能性，从而增加账户关联风险，因此建议卖家使用自己的VAT清关。</p><p>需要注意的是，亚马逊英国运营中心首次收到货件后，卖家有60天时间添加IEN。在此时间段之后，IEN状态将显示为无法编辑，虽然仍然能够查看“IEN”条目，但无法再对其进行编辑。如果没有IEN号，也需要点击填写“不能提供IEN”选项。</p><p>如何填写IEN号？</p><p>通过亚马逊卖家平台“菜单>库存>货件”找到通过该IEN清关的货件编号，在受影响的货件状态下找到“进口详情不全”的IEN窗口。</p> ",
            contentSecond:"<p>选择“该货件有进口记录”并输入有效的IEN。</p>",
            contentThird:"<h4>关于变体违规</h4><p>变体违规的原因</p><p>变体（又称父/子关系）是根据尺寸、颜色、口味等彼此关联的一组商品，比如一款T恤的不同尺寸和颜色，通过变体关联起来，可以在一个Listing页面上看见所有选项。亚马逊上的商品变体，有五种情形可能会被判定为不合规。</p>",
            imgsList:[
            this.$ossUrl+'images/news/newsDetail/3 (2).png' ,
            this.$ossUrl+'images/news/newsDetail/3 (3).png' ,
            this.$ossUrl+'images/news/newsDetail/3 (1).png' ,
            ]
          },
          {
            id:'4',
            title:"重磅！美通正式成为亚马逊TSPN服务商",
            time:"2024-03-11 17:30 · 美通供应链",
            contentFirst:"<p>2024年3月，美通正式成为亚马逊TSPN(Transparency Service Provider Network)服务商！</p> <h4>关于亚马逊TSPN</h4><p>TSPN(Transparency Service Provider Network)即透明计划服务商网络，是亚马逊全球开店品牌保护团队（CNBPS）与服务商之间的中长期合作计划，旨在为卖家提供更好的品牌保护与成长方向的服务和体验。</p><p>对于加入TSPN的服务商，将能够获得亚马逊全球开店品牌保护团队提供一系列权益和资源支持，进而TSPN服务商可以帮助卖家开拓业务，提供更优质的服务。</p><h4>关于透明计划</h4><p>Transparency透明计划是亚马逊为品牌商和消费者提供的一项商品追踪和真伪验证服务。它会对每一件商品进行追踪，保护品牌商和消费者免受假货侵害，帮助品牌在销售的每个触点提升买家信任与忠诚。目前已覆盖亚马逊10大站点：美国、英国、德国法国、西班牙、意大利、印度、加拿大、澳大利亚、日本。</p>",
            contentSecond:"<h4>Transparency透明计划功能介绍：</h4><p><ul><li> Listing创建：开启保护的商品，其他商家想上架相同商品，必须提供对应的Transparency代码，才能正常上架或跟卖。</li><li> 亚马逊物流（FBA）商品入仓：亚马逊会扫描每件产品的Transparency代码，仅接受正品商品入库。</li><li> 自配送商品销售：自配送商品也必须提供对应的Transparency代码才可销售。</li><li> 吸睛“小蓝标”：获得商品详情 Transparency透明计划标记，能快速区别于其他商品，帮助提高转化。</li><li> 小卡片：在商品中放入定制卡片，和买家进行互动，沉淀品牌用户。</li><li> 互动页面：能帮助精准营销、引导留评、提升粉丝粘性、增加商品复购率。</li><li> 退货分析报表：按生产批次、经销商或单个产品，查看消费者退货的原因。</li></ul></p>",
            contentThird:"<p>美通成为亚马逊TSPN服务商，以安全稳定为产品核心，为亚马逊卖家提供等海陆空全时效覆盖的多式联运物流解决方案。卖家可以登录亚马逊SPN官网https://spn.globalsellingcommunity.cn/homePage或微信搜索亚马逊SPN小程序，在【物流】板块找到美通供应链进行咨询合作。</p>",
            imgsList:[
                this.$ossUrl+'images/news/newsDetail/4 (1).png' ,
                this.$ossUrl+'images/news/newsDetail/4 (2).png' ,
                this.$ossUrl+'images/news/newsDetail/4 (1).jpg' ,
                this.$ossUrl+'images/news/newsDetail/4 (3).png' ,
            ]
          },
          {
            id:'5',
            title:"聚焦行业认可，美通荣获雨果跨境“2023最佳跨境物流奖”",
            time:" 2024-03-01 17:59 · 美通供应链",
            contentFirst:"<p>2月28-29日，雨果跨境全球平台资源大会在深圳会展中心4号馆召开。这不仅是雨果跨境在2024年的首场展会，也是跨境出海电商2024开春的行业首场万人大聚会。</p><h6>会上，美通供应链凭借安全、稳定的海陆空全时效覆盖的多式联运物流解决方案与专业优质的服务，荣获“2023年度雨果奖最佳跨境物流奖”。</h6>",
            contentSecond:"<p>此次盛会包含50+跨境平台强势入驻、全球最热平台小众精品电商平台独家链接、200+官方招商经理，1v1不间断问诊、特设站外营销专场，告别流量增长难题、亚马逊，TEMU等平台八场闭门私享会等多个亮点，做到全平台一站式链接，提供出海新机遇。</p>",
            contentThird:"<p>近年来美通迅速发展，围绕“一站式、一揽子、一条龙”的特色运营，在全球建立超30家分公司，产品网络触达主要电商贸易国家与地区，建立超50条自营线路，为客户提供安全、稳定的海陆空全时效覆盖的多式联运物流解决方案。</p>",
            contentForth:"<p>大会颁发了2023年雨果奖多个奖项，其中美通荣获“2023年度雨果奖最佳跨境物流奖”，这一奖项是对美通产品与服务的肯定，也是对美通未来发展的极大鼓舞，感谢所有支持和信任美通的客户、合作伙伴以及社会各界朋友，美通将以此为动力，不忘初心，砥砺前行。</p><p>未来，美通将坚定“做行业领先的跨境电商全球物流服务企业”的愿景，全面发挥并深度挖掘自身在供应链管理、物流体系构建与优化、仓储配送等关键环节的技术优势，实现助力跨境电商五万家企业成功出海的五年目标。</p>",
            imgsList:[
              this.$ossUrl+'images/news/newsDetail/5 (4).jpg' ,
              this.$ossUrl+'images/news/newsDetail/5 (2).jpg' ,
              this.$ossUrl+'images/news/newsDetail/5 (1).webp' ,
              this.$ossUrl+'images/news/newsDetail/5 (3).jpg' ,
              this.$ossUrl+'images/news/newsDetail/5 (5).jpg' ,
              this.$ossUrl+'images/news/newsDetail/5 (1).jpg' ,

            ]
          },
          {
            id:'6',
            title:"新动向：美通成为亚马逊ShipTrack承运商，助力卖家升级物流体验！",
            time:"2024-03-01 17:59 · 美通供应链",
            contentFirst:"<p>美通正式上线亚马逊ShipTrack承运商，亚马逊卖家在创建货件时，系统上选择“非亚马逊合作承运人”板块可以查看并选择使用美通，2月26日后入仓货物的物流轨迹将由系统自动推送到亚马逊后台，便于亚马逊卖家及时全程追踪货物的动态。</p>",
            contentSecond:"<h4>01亚马逊ShipTrack计划是什么？</h4><p>为了帮助广大的中国卖家在亚马逊平台更好地经营，亚马逊在2023年8月底针对中国卖家发出了一条公告，可以为中国卖家的FBA货件提供更加精准的物流追踪服务，对于没有使用官方合作承运商的中国FBA卖家，可以考虑选择参与ShipTrack计划的承运商，这些承运商会自动在卖家中心更新点对点的物流追踪信息。</p><h4>02选择ShipTrack承运商的优势是什么？</h4><h5>无需手动输入追踪编码，简化入仓流程，提升入仓效率</h5><p>卖家不必提供PRO/SPD追踪编码，美通系统已与亚马逊后台对接，美通系统将自动填入，后台自动实时更新物流节点。</p><h5>提供主要追踪节点，提高追踪透明度</h5><p>提供国内入仓、报关放行、开船、到港、清关放行、提柜预约派送、派送日期等全节点的轨迹信息，实时透明，全程追踪。</p><h4>03如何选择ShipTrack美通承运商？</h4><p>1. 后台创建货件时，下拉“选择运输承运人”列表，点击“美通（ShipTrack）”。</p>",
            contentThird:"<p>2. 提供完整的Shipment ID和Reference ID。</p><p>3. 在亚马逊卖家中心的“货件一览”页面“追踪货件”，自动收到推送并查看物流轨迹。</p><h4>04常见问题与解答</h4><p>在哪里可以找到 ShipTrack 承运商列表？</p><p>当卖家使用非合作承运商时，可以在创建货件的第二步（或创建 LTL货件时的第四步）中的“选择承运商”下拉字段中，找到ShipTrack承运商列表。</p><p>使用ShipTrack承运商后，什么时候可以在卖家平台查询到货件单号？</p><p>当ShipTrack承运商收到卖家的产品时，亚马逊即开始在卖家平台的货件摘要页面上显示货件跟踪信息，并在货件抵达亚马逊运营中心后停止刷新货件跟踪信息。在极少数情况下，当跟踪信息没有及时刷新时，请联系承运商。</p><p>美通供应链（AAF）始于2008年，以一站式、一揽子、一条龙的特色运营，提供快捷、优质、安全无忧的国际物流服务，助力跨境电商智联全球。美通渠道产品网络覆盖美国、欧盟、英国、加拿大、墨西哥、日本、俄罗斯等主要电商贸易地区和国家，强有力的海外团队确保目的港清关配送服务顺畅，提供安全、稳定的海陆空全时效覆盖的多式联运物流解决方案。</p><p>美通通过亚马逊的严格筛选与审核流程正式成为亚马逊ShipTrack承运商，标志着美通在物流服务领域的专业度和可靠性得到了一定认可与肯定。展望未来，美通将提供更为优质的配送服务，进一步提升整体体验，并塑造更坚实的竞争优势。</p>",
            imgsList:[
              this.$ossUrl+'images/news/newsDetail/6 (2).png' ,
              this.$ossUrl+'images/news/newsDetail/6 (1).jpg' ,
              this.$ossUrl+'images/news/newsDetail/6 (1).png' ,
            ]
          },
          {
            id:'7',
            title:"展会回顾丨2023亚马逊全球开店峰会美通参展圆满结束！",
            time:"2023-12-16 13:00 · 美通供应链",
            contentFirst:"<p>12月15日，为期四天的2023亚马逊全球开店跨境峰会在深圳国际会展中心圆满结束。作为亚马逊目前规模最大的行业标志性盛会，这次筹备半年、三年多来首次线下峰会现场十分火爆。<strong>美通作为峰会金牌赞助商、亚马逊SPN物流服务商，展位反响热烈、人头攒动，以快捷优质、安全无忧为特色的国际物流服务在现场得到了一致认可与好评。</strong></p> <h4>展会现场</h4>",
            contentSecond:"<p>此次峰会以“新产业布局 高质量出海”为主题，吸引了众多跨境卖家。<strong>美通供应链专注跨境电商物流8年，拥有自营线路50多条，组建多支清关团队，在英国、德国、比利时、美国、加拿大、墨西哥等国家建设自营海外仓，帮助跨境电商卖家快捷、安全、合规出海。</strong></p> ",
            contentThird:"<p>展会上美通以成熟的<strong>“一站式、一揽子、一条龙”</strong>的特色运营模式及相关案例吸引了众多客户，为之后的交流合作奠定了良好的基础。</p> <h4>论坛演讲</h4>",
            contentForth:"<p>在新卖家启航分会场中，美通王安全总经理作了《跨境电商物流全球化和基础建设》主题演讲。王安全总经理从跨境贸易的发展局面出发，引出跨境电商物流的使命，剖析了美通运营能力建设的重点，最后对跨境物流服务品质输出发表了独特的见解。</p><h4>完美收官</h4>",
            contentFive:"<p>至此，2023亚马逊全球开店峰会落下收官帷幕，感谢各位的到来与支持！快捷优质，安全无忧，美通一直在为成为行业领先的跨境电商物流服务企业而努力，路虽远，行则必至。</p>",
            imgsList:[
              this.$ossUrl+'images/news/newsDetail/7 (2).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (15).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (3).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (5).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (6).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (7).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (8).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (9).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (10).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (11).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (12).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (13).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (14).webp' ,
              this.$ossUrl+'images/news/newsDetail/7 (1).webp' ,
            ]
          },
          {
            id:'8',
            title:"喜报！热烈祝贺美通荣获亚马逊“2023金牌辅助”和“SPN一年级奖”",
            time:"2023-10-13 18:10 · 美通供应链",
            contentFirst:"<p>9月28日，亚马逊全球开店华南区域服务商秋兴晚宴在深圳希尔顿酒店举办，本次活动由亚马逊主办。</p> <p>美通受邀参加并成功以专业的全链路物流体系、优质的专业服务、安全稳定靠谱的口碑赢得众多客户的信赖与好评，荣获“2023金牌辅助”和“SPN一年级”奖。在此，非常感谢所有客户的信任与支持！</p>",
            contentSecond:"<h4>晚宴现场 </h4><p>现场聚集了众多具有影响力的跨境电商服务商们，共叙友情，互通有无，现场气氛相当热烈。</p> ",
            contentThird:"<p>美通一直以来坚持以专业彰显服务品质，用品质铸就品牌，以口碑赢未来。美通发展至今已有15年+了，这期间离不开客户们的长期信赖和认可，离不开美通每一位家人的不懈努力与坚持，离不开所有对美通供应链给予支持的合作伙伴们。</p> <p>感恩于心，服务于行，我们将珍惜荣誉，不断开拓进取再突破，时刻秉承“助力跨境智联全球，提供快捷、优质、安全无忧的国际物流服务”的使命，与客户携手并进，扬帆出海，共创未来。</p>",
            contentForth:"<p>深圳市美通供应链有限公司于2008年成立，总部位于跨境电商产业核心商圈的深圳坂田，其总部办公面积5000多平方米，拥有人员规模800多人，国内仓储面积60000多平方米，全自营线路70多条，海内外资源丰富，多航线直接签板，航班密高，自有海外仓和派送车队，专业团队，安全稳定，同时企业在广州、中山、佛山、东莞、上海、义乌、郑州、厦门、青岛等地设立了16家分公司，全球控股和参股公司约34家。</p>",
            imgsList:[
              this.$ossUrl+'images/news/newsDetail/8 (6).webp' ,
              this.$ossUrl+'images/news/newsDetail/8 (2).webp' ,
              this.$ossUrl+'images/news/newsDetail/8 (3).webp' ,
              this.$ossUrl+'images/news/newsDetail/8 (4).webp' ,
              this.$ossUrl+'images/news/newsDetail/8 (5).webp' ,
              this.$ossUrl+'images/news/newsDetail/8 (1).webp' ,
            ]
          },
          {
            id:'9',
            title:"重磅|祝贺美通&央视《信用中国》首播告捷！",
            time:"2023-10-01 18:28 · 美通供应链",
            contentFirst:"<p>9月25日，美通供应链在中央电视台《信用中国》频道顺利完成首播。</p><h4>聚焦发展</h4>",
            contentSecond:"<h4>01莅临指导</h4><p>《信用中国》栏目组以诚信为内涵,在全国范围内遴选出有行业代表性的民营企业出席访谈活动,旨在通过大力宣传自主品牌,提高自主品牌影响力和认知度,在全国范围内打造中国榜样和品牌新势力。</p><p>深圳市美通供应链有限公司是一家全球跨境物流集团，深耕物流领域15年，专注跨境电商物流已有8年经验，总部位于深圳核心商圈——坂田，同时在国内外设立了28家分公司；海外网络遍布至欧洲、北美洲等地。 </p> <p>成立以来自建全球跨境物流国际专线50多条，FBA专线产品覆盖美国、欧盟、英国、加拿大、日本、墨西哥等主要电商贸易地区和国家。</p><p>在全国设有10+个仓库，拥有强大的揽收、仓储、分拨、周转能力。</p> <p>美通供应链可为广大跨境电商客户提供安全、稳定、优质的物流服务。</p> ",
            contentThird:"<h4>02入围选拔</h4><p>《信用中国》栏目组委会鉴于美通供应链在跨境电商物流领域创新发展做出的突出贡献,推动行业发展,为各大跨境电商客户提供安全、稳定、优质的物流服务,特将其列入访谈考察名单。</p> <p>随后,《信用中国》栏目组委对企业资质、管理和服务模式、企业诚信度等进行了深入细致的调查。</p><p>在考察一行中美通供应链有限公司总经理王安全先生向大家介绍了现行业的服务内容及发展理念，企业聚焦物流行业为跨境电商卖家提供一站式全球物流解决方案核心问题,帮助客户创造更大价值,与客户共同成长,物流行业高质量发展。</p><p>最终,美通供应链有限公司凭借良好企业信誉、独特的经营风格以及较强的市场开拓能力通过了栏目组委会的考核。</p>",
            contentForth:"<h4>03录制现场</h4><p>随后美通供应链有限公司总经理王安全先生做客《信用中国》栏目现场,与知名主持人一起探讨了企业发展中的经营管理之道，讲述企业创立初心和品牌发展历程，共同探讨企业发展过程中的企业家精神和企业的品牌故事</p>",
            contentFive:"<p>美通供应链作为跨境电商物流第一家被央视信用中国采访的企业，我们秉承着“安全稳定”的产品核心，助力跨境电商智联全球，为客户持续创造价值，相信不久的将来，美通供应链在大家共同的见证下会越来越好，做出更安全高效的物流体系产品，为客户全方面解决运输难题。</p>",
            imgsList:[
              this.$ossUrl+'images/news/newsDetail/9 (9).webp' ,
              this.$ossUrl+'images/news/newsDetail/9 (2).webp' ,
              this.$ossUrl+'images/news/newsDetail/9 (3).webp' ,
              this.$ossUrl+'images/news/newsDetail/9 (4).webp' ,
              this.$ossUrl+'images/news/newsDetail/9 (5).webp' ,
              this.$ossUrl+'images/news/newsDetail/9 (6).webp' ,
              this.$ossUrl+'images/news/newsDetail/9 (7).webp' ,
              this.$ossUrl+'images/news/newsDetail/9 (8).webp' ,
              this.$ossUrl+'images/news/newsDetail/9 (1).webp' ,
            ]
          },
          {
            id:'10',
            title:"喜讯！美通供应链正式加入亚马逊SPN认证服务商！",
            time:" 2023-08-21 21:00 · 美通供应链",
            contentFirst:"<h4>美通-亚马逊SPN官方认证服务商</h4><p>美通供应链（AAF）始于2008年，公司总部位于跨境电商产业核心商圈的深圳坂田。办公面积5000+平方米，同时在广州、中山、佛山、东莞、上海、义乌、郑州、青岛等地设立十家分公司，并正着力筹建多家新的分支机构。</p><p>美通供应链专注跨境电商物流8年、全自营渠道欧美英日加俄海陆空、电商物流十强企业。在经过亚马逊团队的严格筛选下，美通供应链在公司规模资质，服务质量运营能力，安全实力等方面均得到了亚马逊SPN团队的认可。于2023年8月正式加入Amazon SPN，成为亚马逊官方合作伙伴以及电商卖家信任的专业物流服务商，并为广大的电商卖家提供一站式全球物流解决方案。</p>",
            contentSecond:"<h4>什么是亚马逊SPN？</h4>",
            contentThird:"<p>亚马逊SPN，即亚马逊解决方案提供商网络（Amazon Solution Provider Network），是亚马逊官方通过一套完整的流程和严格的审核标准来评定解决方案提供商的资质，帮助卖家找到规范可靠、经验丰富的优质服务商，全方位解决卖家在运营过程中遇到的难题，助力拓展全球业务。</p><h4>卖家如何在亚马逊官网找到美通？</h4><p>首先先进入SPN首页：https://spn.globalsellingcommunity.cn/homePage</p><p>在顶部搜索栏里搜索“美通供应链”▼</p>",
            contentForth:"<p>找到美通供应链▼</p>",
            contentFive:"<p>点击进入美通的页面▼</p>",
            contentSix:"<p>美通供应链为亚马逊商家提供的服务</p>",
            contentSeven:"<p>最后，非常感谢广大客户一直以来对美通集团跨境电商全球物流的信任与支持。再次感谢亚马逊官方对美通供应链专业和能力的认可，更是品牌实力的体现。</p><p>未来，美通将继续努力，秉承客户至上、诚信、负责任的宗旨，一如既往地为电商客户提供具有竞争力渠道产品，安全稳定的优质物流服务，为跨境电商企业品牌出海献力献策、铺路护航，助力更多电商品牌成功出海！美通跨境电商全球物流，值得信赖！</p>",
            imgsList:[
              this.$ossUrl+'images/news/newsDetail/10 (5).webp' ,
              this.$ossUrl+'images/news/newsDetail/10 (1).webp' ,
              this.$ossUrl+'images/news/newsDetail/10 (3).png' ,
              this.$ossUrl+'images/news/newsDetail/10 (2).png' ,
              this.$ossUrl+'images/news/newsDetail/10 (2).webp' ,
              this.$ossUrl+'images/news/newsDetail/10 (4).webp' ,
              this.$ossUrl+'images/news/newsDetail/10 (1).png' ,
            ]
          },
          {
            id:'11',
            title:"美通供应链作为亚马逊官方认证的FIST承运商，带来了一个好消息——「送达时段自动更新(Delivery Window Automation，简称DW)」功能已正式上线！",
            time:" 2025-12-10 14:30 · 美通供应链",
            contentFirst:"<h3 style='color:#0e6ba2;'>美通供应链已成为首批被亚马逊官方认证拥有三项功能（Ship Track功能+SR智能转仓服务+DW功能）的FIST承运商！</h3>",
            contentSecond:"<h3>一、DW解决卖家核心痛点</h3>",
            contentThird:"<p>作为亚马逊FIST(FBA Inbound Shipment Tracking)体系下的优质承运商，<span style='color:#0e6ba2;font-weight:bold;'>美通供应链早已实现物流数据全程同步的核心优势（Ship Track功能及SR智能转仓服务）</span>：货件从发货、离港、到港、清关到送仓的全节点轨迹，都能在亚马逊卖家平台统一查看，全程透明可追踪。</p>",
            contentForth:"<h4>DW功能上线前：</h4>",
            contentFive:"<p>卖家货件创建后，预计送达时段常因运输实时状态变动需要手动调整，不仅耗时费力，还可能因信息滞后影响供应链规划，甚至导致入库衔接不畅。</p>",
            contentSix:"<h4>DW功能上线后：</h4>",
            contentSeven:"<p><span style='color:#0e6ba2;font-weight:bold;'>美通供应链将全程根据货件实时运输状态，自动帮你管理并更新预计送达时段</span>，无需手动操作就能保证送达信息的准确性，让你省去反复修改的麻烦，更精准地规划库存和运营节奏，省心又高效。</p>",
            contentEight:"<h4>DW 升级精准追踪：</h4>",
            contentNine:"<p>此次DW功能的上线，更是在“全程可追踪”“简化运营”的基础上再升级——依托FIST系统的自动化能力，将物流数据与送达时段动态绑定，让每一次更新都有实时运输数据支撑，准确性和时效性双重保障。<span style='color:#0e6ba2;font-weight:bold;'>确保货件信息全面推送，提供准确的预计送达时段，并在预计送达时段发生变化的第一时间代卖家进行更新。</span></p>",
            contentTen: "<h3>二、DW功能操作指南</h3>",
            contentEleven: "<h4>货件创建时开通（默认勾选即生效）</h4>",
            contentTwelve: "① 登录亚马逊卖家平台，点击【目录】-【库存】-【货件】，进入Send to Amazon页面，<span style='color:#0e6ba2;font-weight:bold;'>确认发货地址为中国</span>及待发送的库存",
            contentThirteen: "② 进入【第2步：确认发货】，选择【使用您自己的承运人】（可点击【FIST优势】图标了解更多FIST承运商详情）；",
            contentFourteen: "③ 关键操作：务必确保两处勾选完整",
            contentFifteen: "一是【送达时段】内勾选【允许FIST承运人更新我的送达时间】",
            contentSixteen: "二是【承运人】处<span style='color:#0e6ba2;font-weight:bold;'>保持默认【非亚马逊合作承运人】-【FIST承运人】勾选，请勿修改，两者缺一不可；</span>",
            contentSeventeen: "④ 后续流程与正常创建货件完全一致，无需额外操作，货件创建完毕后，卖家将会在<span style='color:#0e6ba2;font-weight:bold;'>美通供应链揽收货件并向亚马逊同步推送后</span>，自动看到预计送达时段更新。",
            contentEighteen: "<h4>货件创建后修改（按需恢复手动设置）</h4>",
            contentNineteen: "若后续需要手动调整送达时段，按以下四步操作即可：",
            contentTwenty: "① 进入卖家平台【货件】-【管理货件】，找到目标货件；",
            contentTwentyOne: "② 点击该货件进入【货件一览】页面，选择货件名称右侧相关编号，重新进入Send to Amazon工作流程；",
            contentTwentyTwo: "③ 在【最后一步：追踪详情】，点击【编辑时段】；",
            contentTwentyThree: "④ 取消勾选【更新送达时段】，并手动编辑更新保存即可；",
            contentTwentyFour: "<h3>三、如何找到美通供应链</h3>",
            contentTwentyFive: "想体验DW功能的自动更新便利，直接通过亚马逊全球开店官网",
            contentTwentySix: "（https://gs.amazon.cn/fist/fistlist），或SPN服务商小程序的FIST专属页面，查询最新FIST承运商列表，就能找到美通供应链（AAF）！",
            contentTwentySeven: "美通供应链凭借稳定的物流时效，为你的跨境头程物流保驾护航。无论是全程透明的轨迹追踪，还是省心省力的送达时段自动更新，都能让你专注核心运营，无需为物流细节分心。",
            imgsList:[
              this.$ossUrl+'images/news/newsDetail/0-1.png',
              this.$ossUrl+'images/news/newsDetail/0-2.png',
              this.$ossUrl+'images/news/newsDetail/0-3.png',
              this.$ossUrl+'images/news/newsDetail/0-4.png',
              this.$ossUrl+'images/news/newsDetail/0-5.png',
              this.$ossUrl+'images/news/newsDetail/0-6.png',
              this.$ossUrl+'images/news/newsDetail/0-7.png'
            ]
          },
          {
            id:'12',
            title:"【官宣】美通供应链正式升级为亚马逊FIST Elite承运商",
            time:"2026-09-04 14:30 · 美通供应链",
            contentFirst:"<p>作为专注跨境物流服务的供应链企业，美通供应链持续深耕跨境头程物流领域，依托空运、海运、中欧卡航、铁路等运输方式及全球物流服务网络，为跨境电商卖家提供更加安全、稳定、高效的物流服务。</p><p>继成为亚马逊 FIST 承运商之后，美通供应链凭借出色的绩效表现和综合实力，正式升级成为<span style='color:#0e6ba2;font-weight:bold;'>亚马逊 FIST Elite 承运商</span>。</p><p>这一升级，不仅是对美通供应链物流服务能力与持续稳定绩效表现的认可，也意味着美通供应链将为卖家提供更加全面、高效的跨境物流服务。</p>",
            contentSecond:"<h3>什么是亚马逊FIST？</h3>",
            contentThird:"<p>跨境头程物流环节多、追踪难、操作繁琐，一直是FBA卖家面临的痛点。为此，亚马逊推出了FBA入仓货件追踪智控系统（FIST, FBA Inbound Shipment Tracking），集成多家第三方承运商，实现物流数据同步，并构建透明化、自动化、智能化的产品系统，实现跨境货件的全程可追踪，为卖家减少运营成本，打造更加高效的头程物流体验。目前FIST已覆盖美国、欧洲（英/法/德/意/西）、日本、加拿大等主要站点。</p>",
            contentForth:"<h3>什么是亚马逊FIST Elite？</h3>",
            contentFive:"<p>FIST Elite承运商是亚马逊在FIST承运商中，以更高的绩效指标和持续稳定的高绩效表现为双重准入门槛，经综合评估严格筛选出的优质合作伙伴。<span style='color:#0e6ba2;font-weight:bold;'>FIST Elite承运商可提供ShipTrack、送达时段自动更新（DW Automation）及智能转仓（SR）全部三项FIST产品服务</span>，为卖家带来更全面、更高效的头程物流体验。</p>",
            contentSix:"<h3>美通供应链作为FIST Elite承运商能为卖家带来什么物流支持？</h3>",
            contentSeven:"<h4>1. ShipTrack——让全程物流透明可见，简化运营</h4><p>作为FIST的基础核心功能，ShipTrack从根本上解决了卖家“货件追踪难、手动填单繁”的痛点，其优势：</p><h5>全程可追踪：</h5><p>一站式集成：集成物流服务商系统，及时同步货件轨迹，卖家平台页面统一显示。</p><p>端到端追踪：提供发货、离港、到港、清关、送仓等主要追踪节点更新，提高跨境物流追踪透明度。</p><h5>简化运营：</h5><p>自动输入货件追踪单号，简化卖家操作及入仓流程，提高入仓效率。</p><p>豁免卖家因货件追踪单号不准确造成的入库缺陷，减少卖家绩效影响。</p>",
            contentEight:"<h4>2. DW Automation——送达时段自动更新，告别手动操作繁琐</h4><p>借助DW Automation，卖家无需再手动更新每一票货件的预计送达时段。合作承运商会根据货件的实时运输状态，全程自动更新送达时段，大幅简化操作，同时也提升了预计送达时段的准确性。目前仅支持美国站，其他站点将陆续开发。</p><p>如何使用：卖家只需在货件创建过程中，在默认选项【FIST承运人】后，默认勾选【允许FIST承运人更新我的送达时间】方框即可。其他货件创建流程不会有任何变化，也无需任何额外操作。</p>",
            contentNine:"<h4>一些下单常见错误 | Don'ts：</h4><p>对于卡派（LTL/FTL），务必继续点击至创建货件第4步，并确保【FIST承运人】，及【允许FIST承运人更新我的送达时间】两个方框已勾选，以完成必要授权。如果卖家在第3步提前结束创建货件，将无法成功使用送达时段自动更新。</p>",
            contentTen:"<p>在送达时段处，【允许FIST承运人更新我的送达时间】与【FIST承运人】两处勾选缺一不可。错误选择“其他”或UPS等其它承运商名称选项，将无法完成送达时段自动更新授权，因此无法使用该功能。</p><p>在首次创建货件填写送达时段时，卖家仍需基于当时最佳预估合理选择送达时段。随意选择日期过近的送达时段，会导致承运商揽收后无法进行送达时段更新。</p>",
            contentEleven:"<h4>3. SR——智能转仓，最大程度减少延误</h4><p>当卖家在物流环节中，遇到计划外的延误，造成入库FBA仓库需要延时等待时，选择美通供应链，通过SR智能转仓服务，会根据仓库拥堵情况自动优化入库路径。根据亚马逊的动态数据，及时避开拥堵FBA仓库，将遭遇延误的FBA货件转至其他不拥堵的FBA仓库，有效降低入仓延误风险，实现高效入库。目前仅支持美国、英国、德国站点。</p>",
            contentTwelve:"<h3>在哪里可以查询到美通供应链作为FIST Elite承运商的信息？</h3><p>您可以通过以下方式找到FIST Elite承运商：</p><p>登录亚马逊全球开店网站：https://gs.amazon.cn/fist/fistlist</p>",
            contentThirteen:"<p>进入SPN服务商网络的FIST专属页面，通过“FIST Elite承运商”标签快速筛选</p>",
            contentFourteen:"<h3>常见问题与解答</h3><h4>1. 使用FIST Elite服务是否有额外的附加费用？</h4><p>A：亚马逊推出FIST旨在为卖家带来更好的物流体验，提高跨境物流追踪透明度，帮助卖家减少潜在风险，提高入仓效率。FIST相关服务（ShipTrack、DW Automation、SR）不会有任何附加费用产生。</p><h4>2. FIST Elite和普通FIST承运商有什么区别？</h4><p>A：FIST Elite承运商是亚马逊在FIST承运商中，以更高的绩效指标和持续稳定的高绩效表现为双重准入门槛，经综合评估严格筛选出的优质合作伙伴。FIST Elite承运商可提供ShipTrack、送达时段自动更新（DW Automation）及智能转仓（SR）全部三项产品服务。</p><h4>3. 目前美通供应链支持哪些地区？</h4><p>A：目前美通供应链支持美国/英国/欧洲/加拿大/日本地区。其中：“送达时段自动更新DW Automation”支持美国；“智能转仓SR”支持美国、英国、德国站点。</p><h4>4. 目前美通供应链支持哪些运输方式？</h4><p>A：目前美通供应链美国/英国/欧洲/加拿大/日本站点支持空运/海运。</p><h4>5. 在FIST承运商中选择美通供应链后，什么时候可以在卖家平台查询到货件单号？</h4><p>A：当美通收到卖家的产品时，亚马逊即开始在卖家平台的货件摘要页面上显示货件跟踪信息，并在货件抵达亚马逊运营中心后停止刷新货件跟踪信息。</p><h4>6. 送达时段自动更新后，卖家还需要手动操作吗？</h4><p>A：不需要。只要您在创建货件时保持默认勾选【允许FIST承运人更新我的送达时间】，美通会全程根据实时运输状态自动更新送达时段。但请注意，首次创建货件时仍需基于最佳预估合理选择送达时段。</p><h4>7. 智能转仓服务（SR）需要卖家额外操作吗？</h4><p>A：不需要。当您的货件遭遇入库延误时，美通会自动根据动态数据提供转仓选择，将货件转至不拥堵的FBA仓库，无需卖家额外操作。</p>",
            imgsList:[
              this.$ossUrl+'images/news/newsDetail/12-1.png',
              this.$ossUrl+'images/news/newsDetail/12-2.png',
              this.$ossUrl+'images/news/newsDetail/12-3.png',
              this.$ossUrl+'images/news/newsDetail/12-4.png',
              this.$ossUrl+'images/news/newsDetail/12-5.png',
              this.$ossUrl+'images/news/newsDetail/12-6.png'
            ]
          },
          {
            id:'13',
            title:"美通新航线 | Amazon SEND 欧洲海运渠道首家正式上线！",
            time:"2026-10-10 · 美通供应链",
            contentFirst:"<p><strong>欧洲海运新渠道上线！英国、德国双站直达，助力卖家高效备货、优化物流成本。</strong></p>",
            contentSecond:"<p>做亚马逊欧洲站的卖家都知道，头程物流不只是把货发出去那么简单。</p><p>报价看似便宜，实际却可能叠加仓储、提货、中转等费用；货物发出后，物流轨迹不清晰，跟进起来费时费力；旺季备货，又担心入仓排期影响销售计划。</p><p>针对欧洲站卖家的头程物流需求，卖家可通过亚马逊卖家平台选择美通供应链（AAF）承运服务，将发货、运输及FBA入仓流程有效衔接，美通为卖家提供更便捷的欧洲海运头程选择。</p><p><strong>美通 Amazon SEND 已开通服务站点：</strong></p><p><span style='color:#E67E22;font-weight:bold;'>海运：</span>英国、德国<br><span style='color:#E67E22;font-weight:bold;'>空运：</span>美国、英国、德国</p>",
            contentThird:"<h3>一、欧洲海运双站上线，英国、德国都能发！</h3><p>本次上线Amazon SEND海运英国站、德国站，进一步丰富美通供应链的欧洲FBA头程服务选择。</p><p><strong>Amazon SEND 海运服务</strong></p><ul><li><span style='color:#E67E22;font-weight:bold;'>英国站：</span>中国至英国海运，参考运输时效45–58天</li><li><span style='color:#E67E22;font-weight:bold;'>德国站：</span>中国至德国海运，参考运输时效47–63天</li></ul><p class='news-note'><span style='color:#E67E22;font-weight:bold;'>注：</span>以上时效为自然日参考，实际运输时间可能受到船期、清关、目的地派送及亚马逊仓库预约等因素影响，具体以平台显示及实际运输情况为准。</p><p>无论是英国站常规备货，还是德国站批量补货，卖家都可以根据销售计划与库存情况，选择适合的海运方案。</p>",
            contentForth:"<h3>二、发货成本更清晰，头程预算更好规划</h3><p>做跨境电商，利润不仅取决于销售额，也取决于每一笔物流成本。</p><p>使用Amazon SEND海运服务，卖家可在平台查看对应承运方案及报价，结合货量、时效和备货计划进行选择。</p><p><strong>Amazon SEND 优势：</strong></p><ul><li><span style='color:#E67E22;font-weight:bold;'>亚马逊协议价，</span>价格比同时效的产品更低；</li><li><span style='color:#E67E22;font-weight:bold;'>价格透明，</span>无隐性费用；</li><li><span style='color:#E67E22;font-weight:bold;'>国内仓库入仓费用和中转费全免；</span></li><li><span style='color:#E67E22;font-weight:bold;'>分仓提货费用灵活，</span>节省提货成本；</li><li><span style='color:#E67E22;font-weight:bold;'>物流状态可视化，</span>货件进度随时查。</li></ul>",
            contentFive:"<h3>三、头程怎么安排？上门取件、自送仓均可选择</h3><p>不同卖家的仓库位置、货量及发货习惯各不相同，头程揽收也需要灵活安排。</p><p><strong>Amazon SEND 支持以下两种揽收方式：</strong></p><p><span style='color:#E67E22;font-weight:bold;'>预约上门取件：</span>根据可选时间安排取件，减少自行送仓的协调工作。</p><p><span style='color:#E67E22;font-weight:bold;'>自行送至指定收货点：</span>适合距离承运商收货点较近、希望灵活安排送货时间的卖家。</p>",
            contentSix:"<h3>四、如何使用美通供应链 Amazon SEND 海运服务？</h3><p><strong>新版卖家平台</strong></p><p>卖家平台左侧菜单栏（Menu）👉供应链(Supply Chain) 👉 “Send to Amazon”，选择“Amazon Partner Carrier”创建海运货件。</p><p><strong>旧版卖家平台</strong></p><p>卖家平台左侧菜单栏（Menu）👉库存（Inventory）👉“货件”👉“Send to Amazon”，选择“Amazon Partner Carrier”创建海运货件。</p>",
            contentSeven:"<p>同时也可以扫描下方二维码<span style='color:#E67E22;font-weight:bold;'>与美通高效建联</span></p>",
            contentEight:"<h3>五、美通供应链，助力欧洲 FBA 头程更高效</h3><p>美通供应链是亚马逊<span style='color:#E67E22;font-weight:bold;'>首家五大资质齐全</span>的官方物流服务商，拥有 Amazon SEND、SPN、TSPN、FIST、FIST Elite 五大资质，为跨境卖家提供专业物流服务。</p><p>公司总部位于深圳，全球布局<span style='color:#E67E22;font-weight:bold;'>50+家分公司</span>，拥有<span style='color:#E67E22;font-weight:bold;'>180000+㎡仓储面积</span>，渠道产品网络覆盖<span style='color:#E67E22;font-weight:bold;'>美国、欧盟、英国、加拿大、墨西哥、日本、澳洲</span>等主要电商贸易国家和地区。</p><p>凭借完善的物流网络与服务能力，美通供应链荣获信用中国“重点信用认证企业”，连续六届获得晓生排行榜“FBA物流十强企业”等荣誉。</p><p>此次英国站、德国站海运服务开通，进一步丰富了美通供应链的欧洲FBA头程产品选择，为卖家提供更便捷的发货渠道。</p><p>美通供应链将持续完善跨境物流服务网络，助力中国卖家高效出海、智达全球！</p>",
            imgsList:[
              this.$ossUrl+'images/Amazon SEND.png',
              this.$ossUrl+'images/二维码.png'
            ]
          }
        ]
      };
    },
    methods: {
      processContent() {
      const baseUri = window.location.origin;  // 获取当前网站的根地址
      this.newsContent = this.newsContent.map(item => {
        return {
          ...item,
          content: item.content.replace(/(<img\s+[^>]*?src=['"])([^'"]+)(['"][^>]*>)/g, (match, startTag, src, endTag) => {
            if (!src.startsWith('http')) { // 检查是否是相对路径
              src = `${baseUri}/${src.startsWith('/') ? src.substring(1) : src}`; // 避免双斜杠
            }
            return `${startTag}${src}${endTag}`; // 重构img标签的src属性
          })
        };
      });
    }
    },
    mounted() {
        // this.processContent(); 
    }
    
  };
  </script>
  <style src="./index.css" scoped>
  

  
  
  
  
  </style>